import { render, staticRenderFns } from "./WareHouseList.vue?vue&type=template&id=071a9b67&"
import script from "./WareHouseList.vue?vue&type=script&lang=js&"
export * from "./WareHouseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports